import { getQueryStringParameter } from '../../../helpers';
import { setUpBankContactPhoneField } from '../banking_step';

$(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'banking') {
    return;
  }

  setUpBankContactPhoneField($form);
});
